import { Grid, Typography } from '@mui/material';
import React from 'react';
import MarkdownView from 'react-showdown';

import { formatEpochDate } from 'Lib/stringHelpers';

export function ClientMessageContentDetails(props: any) {
    const {
        classes,
        selectedMessage
    } = props;

    return (
        <Grid
            container
            direction='row'
            spacing={0}
        >
            <Grid
                className={classes.messageContent}
                container
                direction='column'
                item
                spacing={0}
                xs={9}
            >
                <Typography
                    className={classes.headerAttribute}
                    id='clientMessageDetails_messageContent_label'
                    variant='body1'
                >Message
                </Typography>
                <div
                    className={classes.messageHtml}
                    id='clientMessageDetails_messageContent_value'
                >
                    <MarkdownView markdown={selectedMessage?.Message} />
                </div>
            </Grid>
            <Grid
                container
                direction='row'
                item
                justifyContent='space-evenly'
                spacing={0}
                xs={3}
            >
                <Grid
                    alignItems='center'
                    className={classes.messageDateTimeContainer}
                    container
                    direction='column'
                    item
                    justifyContent='center'
                    spacing={0}
                >
                    <Typography variant='body1'>Start Time</Typography>
                    <Grid
                        alignItems='center'
                        className={classes.messageDateContainer}
                        container
                        direction='column'
                        item
                        justifyContent='center'
                        spacing={0}
                    >
                        <Typography
                            className={classes.messageDateMonthDay}
                            variant='h6'
                        >{formatEpochDate(selectedMessage.StartAt, 'DD')}
                        </Typography>
                        <Typography
                            className={classes.messageDateMonth}
                            variant='body1'
                        >{formatEpochDate(selectedMessage.StartAt, 'MMM')}
                        </Typography>
                    </Grid>
                    <Typography variant='body1'>{formatEpochDate(selectedMessage.StartAt, 'HH:mm:ss')}</Typography>
                </Grid>
                <Grid
                    alignItems='center'
                    className={classes.messageDateTimeContainer}
                    container
                    direction='column'
                    item
                    justifyContent='center'
                    spacing={0}
                >
                    <Typography variant='body1'>End Time</Typography>
                    <Grid
                        alignItems='center'
                        className={classes.messageDateContainer}
                        container
                        direction='column'
                        item
                        justifyContent='center'
                        spacing={0}
                    >
                        <Typography
                            className={classes.messageDateMonthDay}
                            variant='h6'
                        >{formatEpochDate(selectedMessage.EndAt, 'DD')}
                        </Typography>
                        <Typography
                            className={classes.messageDateMonth}
                            variant='body1'
                        >{formatEpochDate(selectedMessage.EndAt, 'MMM')}
                        </Typography>
                    </Grid>
                    <Typography variant='body1'>{formatEpochDate(selectedMessage.EndAt, 'HH:mm:ss')}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}